import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { LANG_SIGNAL } from '@lyricstream/shared';
import { scrollToSection } from '../../../core/utils/scroll-to-section';

@Component({
  selector: 'app-privacy',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, RouterLink],
  templateUrl: './privacy.html',
  styleUrl: './privacy.scss',
})
export class PrivacyComponent {
  private readonly platformId = inject(PLATFORM_ID);

  protected readonly lang = inject(LANG_SIGNAL);

  protected readonly sections = [
    { id: 'p1', label: 'Ce que nous collectons' },
    { id: 'p2', label: 'Pourquoi nous le collectons' },
    { id: 'p3', label: 'Ce que nous ne faisons jamais' },
    { id: 'p4', label: 'Cookies et traceurs' },
    { id: 'p5', label: 'Durée de conservation' },
    { id: 'p6', label: 'Partage avec des tiers' },
    { id: 'p7', label: 'Tes droits RGPD' },
    { id: 'p8', label: 'Sécurité technique' },
    { id: 'p9', label: 'Données des mineurs' },
    { id: 'p10', label: 'Contact DPO' },
  ];

  protected readonly activeSection = signal('p1');
  protected readonly year = new Date().getFullYear();

  /** Lien du sommaire : défilement direct (le défilement du routeur ne se déclenche pas, cf. scrollToSection). */
  protected goTo(id: string, event: Event): void {
    event.preventDefault();
    if (scrollToSection(id)) this.activeSection.set(id);
  }

  constructor() {
    afterNextRender(() => {
      if (!isPlatformBrowser(this.platformId)) return;

      // Arrivée avec une ancre dans l'URL (lien partagé) : on y défile.
      const initial = window.location.hash.slice(1);
      if (initial) scrollToSection(initial);

      const headings = document.querySelectorAll<HTMLElement>('.legal-body h2[id]');
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.activeSection.set(entry.target.id);
            }
          }
        },
        { rootMargin: '-80px 0px -60% 0px' },
      );
      headings.forEach((h) => observer.observe(h));
    });
  }
}
